import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type UserFormMessages = SidebarMessages &
  ActionButtonMessages & {
    // Títulos
    permissionsTitle: string;
    userCardTitle: string;

    // Erros
    errorRequiredEmail: string;
    errorInvalidEmail: string;
    errorEmailNotMatching: string;
    errorRequiredLanguage: string;
    errorInvalidLanguage: string;
    errorRequiredPhone: string;
    errorInvalidPhone: string;
    errorRequiredName: string;

    // Rótulos e placeholders
    nameLabel: string;
    namePlaceholder: string;
    emailLabel: string;
    emailPlaceholder: string;
    confirmEmailLabel: string;
    confirmEmailPlaceholder: string;
    languageLabel: string;
    phoneLabel: string;
    phonePlaceholder: string;
    phone2Label: string;
    phone2Placeholder: string;

    soundNotificationLabel: string;
  };

const USER_FORM_MESSAGES: UserFormMessages = {
  // Título
  permissionsTitle: "Permissões do Usuário",
  userCardTitle: "Informações básicas",

  // Erros
  errorRequiredEmail: "Por favor, insira seu e-mail",
  errorInvalidEmail: "Email inválido",
  errorEmailNotMatching: "Campos de email não estão batendo",
  errorRequiredLanguage: "Por favor, escolha um idioma",
  errorInvalidLanguage: "Idioma inválido",
  errorRequiredPhone: "Por favor, insira seu telefone",
  errorInvalidPhone: "Telefone inválido",
  errorRequiredName: "Por favor, insira seu nome",

  // Rótulos e placeholders
  nameLabel: "Nome do usuário",
  namePlaceholder: "Ex: Mateus Duarte",
  emailLabel: "Email",
  emailPlaceholder: "ex: talk2buy@gmail.com",
  confirmEmailLabel: "Confirmar email",
  confirmEmailPlaceholder: "ex: talk2buy@gmail.com",
  languageLabel: "Idioma",
  phoneLabel: "Telefone",
  phonePlaceholder: "Ex: (11) 11111-1111",
  phone2Label: "Telefone secundário",
  phone2Placeholder: "Ex: (11) 11111-1111",

  soundNotificationLabel: "Ativar notificação sonora",

  // ACTION BUTTONS
  ...ACTION_BUTTON_MESSAGES,

  // Mensagens da barra lateral
  ...SIDEBAR_MESSAGES,
};

export default USER_FORM_MESSAGES;
